<template>
  <div class="page-shell course-detail-page">
    <MobileTopNav title="课程详情" />

    <main class="course-detail-main">
      <img
        class="course-detail-image"
        :src="courseImage"
        :alt="`${courseName}课程详情`"
      >
    </main>
  </div>
</template>

<script>
import MobileTopNav from '../components/MobileTopNav.vue'
import { buildUploadAssetUrl } from '../utils/asset'

const courseImages = {
  small: buildUploadAssetUrl('school/small.jpg'),
  middle12: buildUploadAssetUrl('school/middle12.jpg'),
  middle3: buildUploadAssetUrl('school/middle3.jpg'),
  heigh12: buildUploadAssetUrl('school/heigh12.jpg'),
  heigh3: buildUploadAssetUrl('school/heigh3.jpg'),
  yikao: buildUploadAssetUrl('school/yikao.jpg')
}

const courseNames = {
  small: '小学',
  middle12: '初一/初二',
  middle3: '初三',
  heigh12: '高一/高二',
  heigh3: '高三',
  yikao: '艺考'
}

export default {
  name: 'CourseDetailView',
  components: {
    MobileTopNav
  },
  computed: {
    courseKey() {
      const type = this.$route.params.type

      return courseImages[type] ? type : 'small'
    },
    courseImage() {
      return courseImages[this.courseKey]
    },
    courseName() {
      return courseNames[this.courseKey]
    }
  },
  mounted() {
    document.title = '课程详情'
  }
}
</script>

<style scoped>
.course-detail-page {
  min-height: 100vh;
  background: #f6f8fb;
}

.course-detail-main {
  width: 100%;
  min-height: 100vh;
  padding: 0;
}

.course-detail-image {
  display: block;
  width: 100%;
  height: auto;
  background: #fff;
}

@media (max-width: 768px) {
  .course-detail-page {
    background: #fff;
  }

  .course-detail-main {
    min-height: calc(100vh - 48px);
  }
}
</style>
